import ReactiveLoginLink from '@/login/reactive_login_link'

export default ($context = document) => {
  $(() => {
    $('.js-reactive-login-link', $context).each(function () {
      new ReactiveLoginLink($(this))
    })
  })
}
